export default function tracks(state = '', action) {
  if (action.type === 'postprogram' && action.postprogram) {
      var copyPostprogram = JSON.parse(JSON.stringify(action.postprogram));
      return copyPostprogram;
    } else {
      return state;
    };
  };
  